<template>
  <div>
    <el-select :filterable="true" :value="value" value-key="id" placeholder="视图" :size="size" @input="change($event)" :clearable="true">
      <el-option label="----------" :value="emptyValue" />
      <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item" />
    </el-select>
  </div>
</template>

<script>

import { fetchViewList } from '../api/group-view'
export default {
  data () {
    return {
      options: [],
      emptyValue: { id: 0 }
    }
  },
  created () {
    fetchViewList({limit: 0}).then((res) => {
      this.options = res.data.map((item) => { item.id = parseInt(item.id); return item })
    })
  },
  props: ['value', 'size', 'showAllTip', 'showAllTipLabel'],
  methods: {
    change: function (val) {
      this.$emit('input', val)
    },
    handleUpdate () {
      fetchViewList({limit: 0}).then((res) => {
        this.options = res.data
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/card/components/GroupViewSelect.vue